import * as React from 'react';

import { Panel, PanelProps } from 'src/components/panelStack/PanelStack';
import { PanelStackDrawer } from 'src/components/resourceDialog/PanelStackDrawer';
import {
  ProjectFileUploadPreviewDialogContext,
  useProjectFileUploadPreviewDialogContextValue,
} from 'src/containers/ProjectFileUploadPreviewDialogV2/context/useProjectFileUploadPreviewDialog';
import { FileUploadPreviewPanel } from 'src/containers/ProjectFileUploadPreviewDialogV2/panels/FileUploadPreviewPanel';
import { ProjectFileUploadPreviewDialogFooter } from 'src/containers/ProjectFileUploadPreviewDialogV2/ProjectFileUploadPreviewDialogFooter';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const ProjectFileUploadPreviewDialog: React.VFC = () => {
  const dispatch = useReduxDispatch();
  const contextValue = useProjectFileUploadPreviewDialogContextValue();

  const { isOpen } = useReduxSelector(
    (state) => state.ui.fileUploadPreviewDialog
  );

  const initialPanel: Panel<object> = React.useMemo(() => {
    return {
      renderPanel: FileUploadPreviewPanel as (
        props: PanelProps<object>
      ) => React.ReactElement | null,
      props: {},
    };
  }, []);

  const handleClose = () => {
    dispatch(uiSlice.actions.toggledFileUploadPreviewDialog({ isOpen: false }));
  };

  const hasFooterOptions = Boolean(
    contextValue.footerOptions.onBack ||
      contextValue.footerOptions.onNext ||
      contextValue.footerOptions.onCancel ||
      contextValue.footerOptions.onSave
  );

  return (
    <PanelStackDrawer
      ContextProvider={ProjectFileUploadPreviewDialogContext.Provider}
      contextValue={contextValue}
      FooterComponent={ProjectFileUploadPreviewDialogFooter}
      fullSize={contextValue.fullSize}
      hasFooterOptions={hasFooterOptions}
      headerBackButton={contextValue.headerBackButton}
      initialPanel={initialPanel}
      isOpen={isOpen}
      onClose={handleClose}
      title={contextValue.dialogTitle}
    />
  );
};
